'use strict';

// package version injected by `npm run preprocess`
exports.version = '2.35.3';
